/* eslint-disable max-len */
import type { FC } from 'react';

import type { BreakPatternProps } from './breakPatternTypes';

export const SkirtBreak: FC<BreakPatternProps> = props => {
  const { topColor, bottomColor, shadowColor, shadowOpacity = 0.2, ...rest } = props;
  return (
    <svg
      width="1440"
      height="96"
      viewBox="0 0 1440 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      role="presentation"
      {...rest}
    >
      <defs>
        <filter id="break-skirt-shadow" x="0" y="0" width="100%" height="96">
          <feGaussianBlur stdDeviation="15" />
          <feComposite operator="out" in2="SourceGraphic" />
        </filter>
      </defs>

      {/* Top section */}
      <path
        d="M314.31 27.8046C510.98 21.076 546.9 47.315 818.11 47.9843C935 48.4325 1223.03 39.463 1440 0H0V41.5C27.99 42.3963 117.64 34.5331 314.31 27.8106V27.8046Z"
        fill={topColor}
      />

      {/* Bottom section */}
      <path
        d="M0 96H1440V0C1223.03 39.463 935 48.4325 818.11 47.9843C683.948 47.6532 607.363 41.065 540.415 35.3058C472.026 29.4227 413.692 24.4045 314.31 27.8046V27.8106C204.403 31.5674 127.919 35.6805 76.9403 38.4219C36.6967 40.5861 12.3481 41.8954 0 41.5V96Z"
        fill={bottomColor}
      />

      {/* Drop shadow (same path as the top section with the filter applied) */}
      <path
        d="M314.31 27.8046C510.98 21.076 546.9 47.315 818.11 47.9843C935 48.4325 1223.03 39.463 1440 0H0V41.5C27.99 42.3963 117.64 34.5331 314.31 27.8106V27.8046Z"
        fill={shadowColor}
        opacity={shadowOpacity}
        filter="url(#break-skirt-shadow)"
      />
    </svg>
  );
};
